// extracted by mini-css-extract-plugin
export default {"galleryMenu":"SideMenu_galleryMenu__jWPpS","isOpen":"SideMenu_isOpen__DsGwa","navLinksList":"SideMenu_navLinksList__izw-0","navLink":"SideMenu_navLink__DNTm2"};